import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Button, Row, Col, Alert, notification} from "antd";
import "./SignIn.css";
import { Redirect, Link } from "react-router-dom";
import { LoadingOutlined, MailOutlined, KeyOutlined, LockOutlined } from "@ant-design/icons";
import { login, resetErrorMessage } from "../../../Actions/api";
import Cookies from "js-cookie";
// import publicIp from 'public-ip';

function SignIn(props) {
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const token = Cookies.get("JWToken");
  //const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  const { email } = useSelector((state) => state.auth);
  const [form] = Form.useForm();

  const onFinish = async (e) => {
    setLoading(true);
    dispatch(login(e.email, e.password, e.code))
      .then(() => {
        setIsLogin(true);
        setLoading(false);
        dispatch(resetErrorMessage());
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onReset = (e) => {
      form.resetFields();
      setIsLogin(false);
  }

  if (token) {
    notification['success']({
        message: 'Logged in successfully.',
        description: ' ',
        duration: 1.5
      });
      return <Redirect to="/" />;
  }else{
      const reset = localStorage.getItem("reset");
      if(reset==null){
          window.location.reload();
          localStorage.setItem("reset", "true");
      }
  }

  return (
    <div className="SignIn-container" justify="center">
      <div className="signin-title">
        {!isLogin ? "Login" : "Have you received the OTP?"}
      </div>
      <div className="sub-signin-title">
        {!isLogin
          ? "Just one step away from our awesome APIs"
          : `We just sent a code to ${email}`}
      </div>
      {message && (
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
            {<Alert message={message} type="error" />}
          </Col>
        </Row>
      )}
      <Form
        {...layout}
        layout="vertical"
        name="basic"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        className="Signin_form"
        form={form}
      >
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={{span: 12, offset: 6}} xl={{span: 12, offset: 6}} justify="center">
            <Form.Item
              label={<label className="label_login">E-mail</label>}
              name="email"
              rules={!isLogin ? [
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ] : []}
              hidden={isLogin}
            >
              <Input
                addonBefore={<MailOutlined />}
                size="large"
                placeholder=""
                hidden={isLogin}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={{span: 12, offset: 6}} xl={{span: 12, offset: 6}} justify="center">
            <Form.Item
              label={<label className="label_login">Password</label>}
              name="password"
              rules={!isLogin ? [
                {
                  required: true,
                  message: "Please input your password!",
                },
              ] : []}
              hidden={isLogin}
            >
              <Input.Password
                addonBefore={<KeyOutlined />}
                size="large"
                placeholder=""
                hidden={isLogin}
              />
            </Form.Item>
          </Col>
        </Row>
        {!isLogin && (
          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={{span: 12, offset: 6}} xl={{span: 12, offset: 6}} justify="center">
              <div>
                <Link to="/ForgetPassword" className="link">
                  Forget Password?
                </Link>
              </div>
              <div>
                Don't Have an account?{" "}
                {/* {window.location.href.indexOf("staging") !== -1
                ?
                  <Link to="/SignUp" className="link">
                   Sign Up Now!
                  </Link>
                : */}
                  <Link to="/Contact" className="link">
                    Contact Us Now!
                  </Link>
                {/* } */}
               
              </div>
            </Col>
          </Row>
        )}
        
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={{span: 12, offset: 6}} xl={{span: 12, offset: 6}} justify="center">
            <Form.Item
              label={<label className="label_login">Code</label>}
              name="code"
              rules={isLogin ? [
                {
                  required: true,
                  message: "Please input your code!",
                },
                {
                    message: 'Please provide a valid OTP',
                    pattern: /\d+/g
                },
              ] : []}
              hidden={!isLogin}
            >
              <Input
                addonBefore={<LockOutlined />}
                size="large"
                placeholder=""
                maxLength={6}
                hidden={!isLogin}
              />
            </Form.Item>
          </Col>
        </Row>
        {isLogin && (
          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={{span: 12, offset: 6}} xl={{span: 12, offset: 6}} justify="center">
              <div>
                  Didn't received it? Please wait for a few minutes and <Link to="/Login" className="link" onClick={onReset}>try again</Link>
              </div>
            </Col>
          </Row>
        )}
        <br />
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="button_login"
          >
            {loading && <LoadingOutlined />}
            {!isLogin ? 'Login' : 'Verify'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default SignIn;
